<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          申请单号：<span v-if="formData.applyNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
            formData.applyNo
          }}</span>
          <span v-else class="information"> 待生成</span>
          <!-- 状态 -->
          <span v-if="!dataId" class="information"> 新增</span>
          <span v-else class="information">
            {{
              formData.stat == '0' ? '制单' : formData.stat == '1' ? '制单' : formData.stat == '2' ? '审核中' : formData.stat ==
              '5' ? '已审核' : formData.stat == '6' ? '驳回' : formData.stat == '9' ? '已结算' : formData.stat == '99' ? '取消' : ''
            }}</span>
        </div>
        <div class="fr" v-if="sendApplyTypeName==null">
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="editButton && (formData.stat == 1 || formData.stat == 6)" @click="saveData">保存
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && !formData.processId && submitButton"
                     @click="showCloseDialog = true; type = '提交'">提交
          </el-button>
          <el-button type="primary" command="e" class="button-sty" icon="el-icon-check"
                     v-if="(formData.stat == 1 || formData.stat == 6) && formData.id && !formData.processId && flowSubmitButton"
                     @click="startFlow">启动流程
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                     v-if="formData.id != null && formData.stat == 2 && !formData.processId && checkButton"
                     @click="showCloseDialog = true; type = '审核'">审核
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                     v-if="formData.id != null && formData.stat == 2 && !formData.processId && rejectButton"
                     @click="showCloseDialog = true; type = '驳回'">驳回
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-close"
                     v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && !formData.processId && cancelButton"
                     @click="showCloseDialog = true; type = '取消'">取消
          </el-button>
        </div>
        <div class="fr" v-if="sendApplyTypeName=='特殊费用核销申请'">
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="editButtonTsfy && (formData.stat == 1 || formData.stat == 6)" @click="saveData">保存
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && !formData.processId && submitButtonTsfy"
                     @click="showCloseDialog = true; type = '提交'">提交
          </el-button>
          <el-button type="primary" command="e" class="button-sty" icon="el-icon-check"
                     v-if="(formData.stat == 1 || formData.stat == 6) && formData.id && !formData.processId && flowSubmitButtonTsfy"
                     @click="startFlow">启动流程
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                     v-if="formData.id != null && formData.stat == 2 && !formData.processId && checkButtonTsfy"
                     @click="showCloseDialog = true; type = '审核'">审核
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                     v-if="formData.id != null && formData.stat == 2 && !formData.processId && rejectButtonTsfy"
                     @click="showCloseDialog = true; type = '驳回'">驳回
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-close"
                     v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && !formData.processId && cancelButtonTsfy"
                     @click="showCloseDialog = true; type = '取消'">取消
          </el-button>
        </div>
        <div class="fr" v-if="sendApplyTypeName=='质量问题产品退回管理费核销申请'">
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="editButtonZlwt && (formData.stat == 1 || formData.stat == 6)" @click="saveData">保存
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && !formData.processId && submitButtonZlwt"
                     @click="showCloseDialog = true; type = '提交'">提交
          </el-button>
          <el-button type="primary" command="e" class="button-sty" icon="el-icon-check"
                     v-if="(formData.stat == 1 || formData.stat == 6) && formData.id && !formData.processId && flowSubmitButtonZlwt"
                     @click="startFlow">启动流程
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                     v-if="formData.id != null && formData.stat == 2 && !formData.processId && checkButtonZlwt"
                     @click="showCloseDialog = true; type = '审核'">审核
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                     v-if="formData.id != null && formData.stat == 2 && !formData.processId && rejectButtonZlwt"
                     @click="showCloseDialog = true; type = '驳回'">驳回
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-close"
                     v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && !formData.processId && cancelButtonZlwt"
                     @click="showCloseDialog = true; type = '取消'">取消
          </el-button>
        </div>
        <div class="fr" v-if="sendApplyTypeName=='社会化服务商退换货物流运输费申请'">
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="editButtonShh && (formData.stat == 1 || formData.stat == 6)" @click="saveData">保存
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && !formData.processId && submitButtonShh"
                     @click="showCloseDialog = true; type = '提交'">提交
          </el-button>
          <el-button type="primary" command="e" class="button-sty" icon="el-icon-check"
                     v-if="(formData.stat == 1 || formData.stat == 6) && formData.id && !formData.processId && flowSubmitButtonShh"
                     @click="startFlow">启动流程
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                     v-if="formData.id != null && formData.stat == 2 && !formData.processId && checkButtonShh"
                     @click="showCloseDialog = true; type = '审核'">审核
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                     v-if="formData.id != null && formData.stat == 2 && !formData.processId && rejectButtonShh"
                     @click="showCloseDialog = true; type = '驳回'">驳回
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-close"
                     v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && !formData.processId && cancelButtonShh"
                     @click="showCloseDialog = true; type = '取消'">取消
          </el-button>
        </div>
      </div>
      <div>
        <div>
          <!-- 品牌信息 -->
          <div class="d-cont edit-mce-box" style="height: 100%;margin:0 !important;padding:0 !important;">
            <div class="d-item">
              <div class="title first">
                <b>主信息</b>
              </div>
              <table class="table-detail">
                <tbody>

                <tr>
                  <th>
                    <em class="f-red">*</em>
                    申请类型
                  </th>
                  <td>
                    <el-select v-model="formData.applyType" style="width:10vw!important;" @change="applyTypeChange"
                               clearable :disabled="this.applyTypeDisable">
                      <el-option v-for="item in applyTypeList" :key="item.id" :label="item.label" :value="item.id">
                      </el-option>
                    </el-select>
                  </td>
                  <th>
                    <em class="f-red" v-if="needFee">*</em>
                    费用类型
                  </th>
                  <td>
                    <el-select v-model="feeTypeValue"  style="width:10vw!important;" clearable @change="feeTypeValueListChange(1)"
                               :disabled="this.notFeeTypeFlag">
                      <el-option v-for="item in feeTypeList" :key="item.id" :label="item.label" :value="item.id">
                      </el-option>
                    </el-select>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    机构名称
                  </th>
                  <td>
                    <el-cascader v-model="orgValue" :options="orgOptions"
                                 :props="{ label: 'name', value: 'id', checkStrictly: true }"
                                 @change="orgHandleChange"></el-cascader>
                  </td>
                  <!-- <td v-if="this.currentSiteData!==null">
                    <el-cascader v-model="orgValue" :options="orgOptions" @change="orgHandleChange" :disabled="true" />
                  </td> -->
                  <!-- <td v-else>
                    <el-cascader v-model="orgValue" :options="orgOptions" @change="orgHandleChange"/>
                  </td> -->
                  <th>
                    <em class="f-red">*</em>
                    网点名称
                  </th>
                  <td v-if="this.currentSiteData !== null">
                    <el-input type="text" autocomplete="off" v-model="formData.siteName" clearable :disabled="true">
                      <i slot="suffix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                  </td>
                  <td v-else>
                    <el-input type="text" autocomplete="off" v-model="formData.siteName" @change="changeSite" clearable>
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="showSitePop = true"></i>
                    </el-input>
                  </td>
                </tr>
<!--                <tr v-if="needOrderNoAndBarCodeFlag">-->
<!--                  <th>-->
<!--                    <em class="f-red">*</em>-->
<!--                    工单号-->
<!--                  </th>-->
<!--                  <td>-->
<!--                    <el-input type="text" autocomplete="off" v-model="formData.orderNo" clearable-->
<!--                              readonly>-->
<!--                      <i slot="suffix" class="el-input__icon el-icon-search" @click="searchOrder"></i>-->
<!--                    </el-input>-->
<!--                  </td>-->
<!--                  <th>-->
<!--                    <em class="f-red"></em>-->
<!--                    条码-->
<!--                  </th>-->
<!--                  <td>-->
<!--                    <el-input type="text" autocomplete="off" v-model="formData.barcode" clearable/>-->
<!--                  </td>-->
<!--                  <th>-->
<!--                    费用结算类型-->
<!--                  </th>-->
<!--                  <td>-->
<!--                    <el-select v-model="formData.settleFeeType" style="width:7vw" disabled>-->
<!--                      <el-option label="安装" :value="1"/>-->
<!--                      <el-option label="维修" :value="2"/>-->
<!--                      <el-option label="其他" :value="9"/>-->
<!--                    </el-select>-->
<!--                  </td>-->
<!--                </tr>-->
                <tr>
                  <th>
                    联系方式
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.siteMobile" clearable/>
                  </td>
                  <th >
                    <em class="f-red" v-if="canChangeSettleFee">*</em>
                    费用结算类型
                  </th>
                  <td >
                    <el-select v-model="formData.settleFeeType" style="width:7vw" @change="changeSettleFeeType" :disabled="!canChangeSettleFee" >
                      <el-option label="安装" :value="1"/>
                      <el-option label="维修" :value="2"/>
                      <el-option label="其他" :value="9"/>
                    </el-select>
                  </td>
                  <th>
                    结算单号
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.settleNo" disabled/>
                  </td>
                  <th>
                    冲账单号
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.offAccountingNo" disabled/>
                  </td>
                </tr>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    申请内容
                  </th>
                  <td colspan="7">
                    <el-input type="textarea" autocomplete="off" v-model="formData.applyContent" clearable/>
                  </td>
                </tr>
                <tr>
                  <th>
                    补充申请内容
                  </th>
                  <td colspan="7">
                    <el-input type="text" autocomplete="off" v-model="formData.applyContnetExtend" clearable/>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
            <div class="d-item" v-if="isSpecialApplyType" style="position: relative;">
                <div class="title first"><b>工单列表</b></div>
                <div style="position: absolute;right: 3%;top: 0;" v-if="!formData.stat || formData.stat ==1">
                  <el-button type="primary" class="button-sty btn_zdy"
                             @click="searchOrder()">
                    <i class="el-icon-plus"></i>
                    新增明细
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy"
                             @click="importOrders()">
                    <i class="el-icon-plus"></i>
                    批量导入
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy"
                             @click="deleteCompanyFeeMed">
                    <i class="el-icon-delete"></i>
                    删除明细
                  </el-button>
                </div>
              <div>
                <vxe-table style="margin-top: 0px;" :stripe="true"
                           :header-cell-style="{ height: '36px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 36, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           show-overflow height="210" :column-config="{ resizable: true }"
                           @checkbox-change="selectChangeEvent"
                           show-footer-overflow
                           show-header-overflow
                           tableWidth="1200"
                           :auto-resize="true"  :resizable="true"
                           @checkbox-all="selectChangeEvent" :data="formData.wkFeeApplyOrderList">
                  <vxe-column type="checkbox" width="40"/>
                  <vxe-column field="orderNo" title="工单号" key="orderNo" width="120" />
                  <vxe-column field="brandName" title="品牌"  key="brandName" width="80"/>
                  <vxe-column field="partsApplyNo" title="配件申请单号" key="partsApplyNo" width="120">
                    <template slot-scope="{ row,index }" >
                      <el-input type="text"  v-model="row.partsApplyNo"   readonly :disabled="!formData.stat===1">
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="changePartsApply(row)"></i>
<!--                        <el-button class="el-icon-search" @click="changePartsApply(row)" v-if="formData.stat===1"></el-button>-->
                      </el-input>
                    </template>
                  </vxe-column>
                  <vxe-column field="partsCode" title="配件编码" key="partsCode" width="120">
                    <template slot-scope="{ row,index }" >
                      <el-input type="text"  v-model="row.partsCode"  :disabled="!formData.stat===1">
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="changeOrderPartsApply(row)"></i>
                      </el-input>
                    </template>
                  </vxe-column>
                  <vxe-column field="partsName" title="配件名称" key="partsName" width="120"/>
                  <vxe-column field="partsQty" title="配件数量" key="partsQty" width="120">
                    <template slot-scope="{ row,index }" >
                      <el-input type="text"  v-model="row.partsQty"  :disabled="!row.canChangePartsQty"/>
                    </template>
                  </vxe-column>

                  <vxe-column field="factPartsCode" title="实收配件编码" key="factPartsCode" width="120" />
                  <vxe-column field="factPartsQty" title="实收数量" key="factPartsQty" width="120"/>


                  <vxe-column field="barcode" title="条码" key="barcode" width="120">
                    <template slot-scope="{ row,index }" >
                      <el-input type="text"  v-model="row.barcode" style="width: 8vw;" :disabled="!formData.stat===1"></el-input>
                    </template>
                  </vxe-column>
                  <vxe-column field="content" title="申请内容" width="250" key="content" >
                    <template slot-scope="{ row,index }">
                      <el-input type="text"  v-model="row.content" style="width: 8vw;" :disabled="!formData.stat===1"></el-input>
                    </template>
                  </vxe-column>
                  <vxe-column v-if="currentIsSite" field="applyAmount" title="申请金额" key="applyAmount" width="120">
                    <template slot-scope="{ row,index }">
                      <span>*</span>
                    </template>
                  </vxe-column>
                  <vxe-column v-if="!currentIsSite" field="applyAmount" title="申请金额" key="applyAmount" width="120">
                    <template slot-scope="{ row,index }">
                      <el-input type="number"  v-model="row.applyAmount" style="width: 8vw;" :disabled="!formData.stat===1" @input="changeCheckAmount(row)"></el-input>
                    </template>
                  </vxe-column>
                  <vxe-column field="hxRate" title="核销比例（%）" key="hxRate" width="120">
                    <template slot-scope="{ row,index }">
                      <el-input type="number"  v-model="row.hxRate" readonly style="width: 8vw;" :disabled="!formData.stat===1" @input="changeCheckAmount(row)"></el-input>
                    </template>
                  </vxe-column>
                  <vxe-column v-if="!currentIsSite" field="checkAmount" title="审核金额" key="checkAmount" width="120">
                    <template slot-scope="{ row,index }">
                      <el-input type="text"  v-model="row.checkAmount" style="width: 8vw;" disabled></el-input>
                    </template>
                  </vxe-column>

                  <vxe-column v-if="currentIsSite" field="applyAmount" title="审核金额" key="applyAmount" width="120">
                    <template slot-scope="{ row,index }">
                      <span>*</span>
                    </template>
                  </vxe-column>

                  <vxe-column field="checkResult" title="审核结果" key="checkResult" width="120">
                    <template slot-scope="{ row,index }">
                      <el-select v-model="row.checkResult" style="width:100px" disabled>
                        <el-option :value="Number(1)" label="通过"></el-option>
                        <el-option :value="Number(2)" label="不通过"></el-option>
                      </el-select>
                    </template>
                  </vxe-column>
                  <vxe-column field="rejectRemark" title="说明" key="rejectRemark" width="120">
                    <template slot-scope="{ row,index }">
                      <el-input type="text"  v-model="row.rejectRemark" style="width: 8vw;" disabled></el-input>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>
            </div>
            <div class="d-item">
              <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                <div class="title first"><b>附件列表</b></div>
                <el-upload style="display:flex; float: right" class="upload-demo" ref="upload"
                           :action="api.uploadFileUrl"
                           accept=".docx,.doc,.txt,.pdf,.xlsx" :limit="3" :show-file-list="false"
                           :on-success="(res, file, fileList) => { handleFileSuccess(res, file, fileList) }"
                           :headers="headers"
                           :on-progress="upVideo"

                           :auto-upload="true">
                  <el-button type="primary" class="button-sty btn_zdy">
                    <i class="el-icon-plus"></i>
                    附件
                  </el-button>
                </el-upload>
              </div>
              <div>
                <vxe-table style="margin-top: 0px;" :stripe="true"
                           :header-cell-style="{ height: '36px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 36, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           show-overflow height="210" :column-config="{ resizable: true }"
                           @checkbox-change="selectChangeEvent"
                           @checkbox-all="selectChangeEvent" :data="formData.fileList">
                  <vxe-column type="checkbox" width="40"/>
                  <vxe-column field="fileName" title="附件名称" width="400">
                    <template #default="{ row }">
                      <!-- <a :href="row.fileUrl" :download="row.fileName">{{ row.fileName }}</a> -->
                      <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>

                    </template>
                  </vxe-column>
                  <vxe-column title="操作" width="90">
                    <template #default="{ row }">
                      <div>
                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                    popper-class="tooltip-skin">
                          <i @click="deleteFile(row)" class="el-icon-delete"
                             style="font-size: 18px; color: #00c4b3"></i>
                        </el-tooltip>

                        <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                                    popper-class="tooltip-skin">
                          <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                             style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                        </el-tooltip>

                        <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
                                    popper-class="tooltip-skin">
                          <i @click="openVideo(row.fileUrl)" class="el-icon-view"
                             style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>
            </div>
            <div class="d-item">
              <div class="title first">
                <b>审核信息</b>
              </div>
              <table class="table-detail">
                <tbody>
                <tr>
                  <th>
                    审核人
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.checkBy" clearable :disabled="able"/>
                  </td>
                  <th>
                    审核时间
                  </th>
                  <td>
                    <el-date-picker v-model="formData.checkDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
                                    :disabled="able" type="date" placeholder="选择日期">
                    </el-date-picker>
                  </td>
                  <th>
                    结算金额
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.checkAmount" clearable
                              :disabled="able"/>
                  </td>
                </tr>
                <tr>
                  <th>
                    审核说明
                  </th>
                  <td colspan="3">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" autocomplete="off"
                              v-model="formData.checkNote" clearable :disabled="able"/>
                  </td>
                  <th>审核附件</th>
                  <td colspan="5">
                    <div class="form_picture">
                      <!-- <photo-upload :photo-url.sync="company.electronicInstructionManual"/> -->
                      <text-upload :photo-url.sync="checkFile" :disabled="able"/>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="d-item" style="position: relative;">
              <div class="title first" style="    display: flex;justify-content: space-between;align-items: center;">
                <b>服务商异议</b>
              </div>
              <table class="table-detail">
                <tbody>
                <tr>
                  <th>
                    服务商是否异议
                  </th>
                  <td>
                    <el-select v-model="formData.diffFlag" :disabled="able">
                      <el-option :value="0" label="否"/>
                      <el-option :value="1" label="是"/>
                    </el-select>
                  </td>
                  <th>
                    异议说明
                  </th>
                  <td colspan="3">
                    <el-input type="textarea" autocomplete="off" v-model="formData.diffNote" clearable
                              :disabled="able"/>
                  </td>
                </tr>
                <tr>
                  <th>异议附件</th>
                  <td colspan="5">
                    <div class="form_picture">
                      <!-- <photo-upload :photo-url.sync="company.electronicInstructionManual"/> -->
                      <text-upload :photo-url.sync="formData.diffFile" :disabled="able"/>

                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <wfView visible-key="showEdit" :wfData="wfData" :obj="fixData" :parent-target="_self"
                    @reloadWf="reloadWf"></wfView>
            <div style="height:250px"></div>
          </div>
        </div>
      </div>
    </el-form>

    <el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList"/>

    <sitePop v-if="showSitePop" :visiable.sync="showSitePop" :multi="true" @commit="siteCommit" :orgId="formData.orgId" :siteFloorLevel="1"
             multi="true"/>

    <closeDialog v-if="showCloseDialog" :dataId="formData.id" :confirmNo="formData.applyNo" :type="type"
                 @closeD="closeD"
                 :visiable.sync="showCloseDialog" multi="true" @goBackIndex="goBackIndex"/>

    <confirmDialog v-if="showConfirmDialog" :confirmNo="formData.billNo" :dataId="dataId" @closeD="closeD"
                   :visiable.sync="showConfirmDialog" multi="true" @flushed="editViewDataUpdate"/>

    <auditDialog v-if="showAuditDialog" :dataId="dataId" @closeD="closeD" :visiable.sync="showAuditDialog" multi="true"
                 @flushed="editViewDataUpdate"/>
    <!-- 回访-->
    <orderRemark v-if="showOrderRemaekDialog" @followUpOrderRemark="followUpOrderRemark"
                 :visiable.sync="showOrderRemaekDialog" :param="orderRemarkParam"/>
    <!-- 文件预览 -->
    <Preview v-if="showPreview" @closeD="closeD2" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL"/>

    <orderPop v-if="showOrderPop" @commit="orderCommit" :visiable.sync="showOrderPop" :showBigSiteName="true"
              :bigSiteId="formData.siteId" :isFromFeeApply="isFromFeeApply" :feeTypes="feeTypes" :settleType = "formData.settleFeeType"
              multi="true"/>

    <partsApplyLineDialog v-if="showPartsApply" :visiable.sync="showPartsApply" @commitSelectedRow="commitPartsApplyNoRow"/>
    <orderPartsApplyLineDialog v-if="showOrderPartsApply" :visiable.sync="showOrderPartsApply"
                                :order-no="currentRowData.orderNo"
                               :apply-no="currentRowData.partsApplyNo"
                               @commitSelectedOrderRow="commitPartsSelectNoRow"
     />
    <excel-upload
      ref="excelUpload"
      title="批量导入工单"
      :data="{siteId:formData.siteId,settleFeeType:formData.settleFeeType}"
      url="/basic/wkFeeApply/importApplyOrders"
      temp-url="/admin/sys-file/local/file/wkFeeApplyOrders.xlsx"
      @refreshDataList="refreshChange"
    ></excel-upload>
  </div>
</template>
<script>
import checkSubjectSearch from "@/components/formItem/checkSubjectSearch.vue"
import Tinymce from '@/components/Tinymce';
import store from "@/store";
import api from '@/api/projectApi'
import {uploadFileFormat, echoFileFormat} from '@/util/uploadFormat'
import sitePop from "@/views/dialogCommon/radioSiteDialog.vue"
import auditDialog from "@/views/expense/assessment/assessment1/auditDialog.vue";
import confirmDialog from "@/views/expense/assessment/assessment1/confirmDialog.vue";
import closeDialog from "./closeDialog.vue";
import DictSelect from "@/components/formItem/dictSelect.vue";
import request from "@/router/axios";
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
import {mapGetters} from "vuex";
import {siteMixins} from "@/mixins/tabChang";
import {dictType, loadDictData} from "@/config/dictType";
// 回访
import orderRemark from "./starLevel.vue";
// 文件上传
import textUpload from "@/components/formItem/textUpload.vue"
// 流程
import wfView from "@/views/dialogCommon/wfMsgDialog.vue";
import {delObj, fetchTree, syncCpDept, syncCpUser, syncDept, syncUser} from '@/api/admin/dept'
// 文件预览
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
import ExcelUpload from "@/components/upload/excelByData.vue";
import radioPartsDialog from "@/views/dialogCommon/radioPartsDialog.vue";
import PartsApplyLineDialog from "@/views/dialogCommon/partsApplyLineDialog.vue";
import OrderPartsApplyLineDialog from "@/views/dialogCommon/orderPartsApplyLineDialog.vue";

export default {
  mixins: [siteMixins],
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    processId: [String, Number],
    type: String,

    applyTypeName: [String, Number],
    sendApplyTypeName: String,
    applyTypeDisable: [String, Boolean],
  },
  components: {
    OrderPartsApplyLineDialog,
    PartsApplyLineDialog,
    radioPartsDialog,
    ExcelUpload,
    Preview,
    textUpload,
    wfView,
    orderRemark,
    DictSelect,
    checkSubjectSearch,
    orderPop,
    closeDialog, confirmDialog, auditDialog,
    sitePop,
    Tinymce,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      isFromFeeApply: 1,
      feeTypes: [],
      checkFile: [],
      applyTypeDisable: false,
      applyTypeName: null,

      fixData: null,

      imgVisbleURL: '',

      showPreview: false,
      processDefinitions: [],

      // 号码验证
      callMobile1: '',

      applyTypeList: [],
      feeTypeList: [],
      feeTypeValue: '',

      feeTypeValueList: [],

      able: true,

      submitButton: false,
      flowSubmitButton: false,
      checkButton: false,
      rejectButton: false,
      cancelButton: false,
      //特殊费用
      addButtonTsfy: false,
      editButtonTsfy: false,
      exportButtonTsfy: false,
      flowSubmitButtonTsfy: false,
      checkButtonTsfy: false,
      rejectButtonTsfy: false,
      cancelButtonTsfy: false,

      //质量问题
      addButtonZlwt: false,
      editButtonZlwt: false,
      exportButtonZlwt: false,
      flowSubmitButtonZlwt: false,
      checkButtonZlwt: false,
      rejectButtonZlwt: false,
      cancelButtonZlwt: false,
      //社会化
      addButtonShh: false,
      editButtonShh: false,
      exportButtonShh: false,
      flowSubmitButtonShh: false,
      checkButtonShh: false,
      rejectButtonShh: false,
      cancelButtonShh: false,
      showPartsApply:false,
      showOrderPartsApply:false,
      currentRowData:{
        orderNo:null,
        applyNo:null,
        partsQty:0,
      },
      recallButton: false,
      editButton: true,
      selectedData: [],
      orgOptions: {},
      queryParams: {
        deptName: ""
      },
      orgValue: '',
      showOrderRemaekDialog: false,
      orderRemarkParam: {},

      loading: false,
      // 流程
      processId: '',
      showOrderPop: false,

      wfData: {
        wfEntityId: ''
      },
      initiateAppeal: false,
      formLabelWidth: '80px',
      justShow: false,
      showCloseDialog: false,
      showConfirmDialog: false,
      showAuditDialog: false,
      isSite: false,
      notFeeTypeFlag: false,
      needFee: true,
      needOrderNoAndBarCodeFlag: false,
      isSpecialApplyType:false,
      canChangeSettleFee:false,
      selectSettleFeeType:null,
      isSetSettleFeeType:false,

      dialogImageUrlList: [],
      dialogVisible: false,
      uploadFileUrl: api.uploadFileUrl,

      form2: {
        appealRemark: '',
        siteAnswerNote: '',
      },
      formData: {
        id: null,
        fileList: [],
        wkFeeApplyOrderList:[],
        // createBy: '', // 创建人
        // createTime: '', // 创建时间
        // modifyBy: '', // 修改人
        // modifyTime: '', // 修改时间
        // version: '', // 版本
        // entId: '', // 组织号，关联bas_ent.id
        // remark: '', // 备注
        // companyId: '', // 厂商ID,关联sys_tenant.id
        processId: null,
        applyNo: '', // 申请单号;前缀"FA"+年月日+6位流水号
        applyType: '', // 费用事务单申请类型ID,关联脚手架数据字典项目表sys_dict_item.id。华帝初始化三个类型:1特殊费用核销申请;2质量问题产品退回管理费核销申请;3社会化服务商退换货物流运输费申请
        applyTypeName: '', // 费用事务单申请类型名称,冗余字段
        feeType: '', // 费用事务单费用类型ID,关联脚手架数据字典项目表sys_dict_item.id。华帝初始化三个类型：1安装维修费用核销;2三包配件核销;3面板核销
        feeTypeName: '', // 费用事务单费用类型名称,冗余字段
        stat: 1, // 单据状态:1制单;2审核中;5已审核;6驳回;99取消
        orgId: '', // 部门ID，关联脚手架机构表sys_dept.dept_id
        orgName: '', // 部门名称,冗余字段
        orgIdPath: '', // 部门ID路径,冗余字段.重要
        siteId: '', // 网点ID,关联sn_user.id;
        siteName: '', // 网点名称, 冗余字段
        siteMobile: '', // 联系方式
        applyContent: '', // 申请内容
        applyContnetExtend: '', // 补充申请内容
        checkBy: '', // 审核人
        checkDate: '', // 审核时间
        checkAmount: '', // 结算金额
        checkNote: '', // 审核说明
        checkFile: '', // 审核附件
        diffFlag: '', // 服务商是否异议：0否1是
        diffNote: '', // 异议说明
        diffFile: '', // 异议附件

        orderNo: '',
        barcode: '',
        settleFeeType:''
      },
      dataRule: {
        // createBy: [
        //   { required: true, prop:'创建人', message: '创建人不能为空', trigger: 'blur' }
        // ],
        // createTime: [
        //   { required: true, prop:'创建时间', message: '创建时间不能为空', trigger: 'blur' }
        // ],
        // modifyBy: [
        //   { required: true, prop:'修改人', message: '修改人不能为空', trigger: 'blur' }
        // ],
        // modifyTime: [
        //   { required: true, prop:'修改时间', message: '修改时间不能为空', trigger: 'blur' }
        // ],
        // version: [
        //   { required: true, prop:'版本', message: '版本不能为空', trigger: 'blur' }
        // ],
        // entId: [
        //   { required: true, prop:'组织号，关联bas_ent.id', message: '组织号，关联bas_ent.id不能为空', trigger: 'blur' }
        // ],
        // remark: [
        //   { required: true, prop:'备注', message: '备注不能为空', trigger: 'blur' }
        // ],
        // applyNo: [
        //   { required: true, prop:'申请单号;前缀"FA"+年月日+6位流水号', message: '申请单号;前缀"FA"+年月日+6位流水号不能为空', trigger: 'blur' }
        // ],
        applyType: [
          {
            required: true,
            prop: '费用事务单申请类型ID,关联脚手架数据字典项目表sys_dict_item.id',
            message: '费用事务单申请类型ID,关联脚手架数据字典项目表sys_dict_item.id',
            trigger: 'blur'
          }
        ],
        applyTypeName: [
          {
            required: true,
            prop: '费用事务单申请类型名称,冗余字段',
            message: '费用事务单申请类型名称,冗余字段不能为空',
            trigger: 'blur'
          }
        ],
        // feeType: [
        //   { required: true, prop:'费用事务单费用类型ID,关联脚手架数据字典项目表sys_dict_item.id', message: '费用事务单费用类型ID,关联脚手架数据字典项目表sys_dict_item.id', trigger: 'blur' }
        // ],
        // feeTypeName: [
        //   { required: true, prop:'费用事务单费用类型名称,冗余字段', message: '费用事务单费用类型名称,冗余字段不能为空', trigger: 'blur' }
        // ],
        // stat: [
        //   { required: true, prop:'单据状态:1制单;2审核中;5已审核;6驳回;99取消', message: '单据状态:1制单;2审核中;5已审核;6驳回;99取消不能为空', trigger: 'blur' }
        // ],
        orgId: [
          {
            required: true,
            prop: '部门ID，关联脚手架机构表sys_dept.dept_id',
            message: '部门ID，关联脚手架机构表sys_dept.dept_id不能为空',
            trigger: 'blur'
          }
        ],
        orgName: [
          {required: true, prop: '部门名称,冗余字段', message: '部门名称,冗余字段不能为空', trigger: 'blur'}
        ],
        orgIdPath: [
          {
            required: true,
            prop: '部门ID路径,冗余字段.重要',
            message: '部门ID路径,冗余字段.重要不能为空',
            trigger: 'blur'
          }
        ],
        siteId: [
          {required: true, prop: '网点ID,关联sn_user.id;', message: '网点ID,关联sn_user.id;不能为空', trigger: 'blur'}
        ],
        siteName: [
          {required: true, prop: '网点名称, 冗余字段', message: '网点名称, 冗余字段不能为空', trigger: 'blur'}
        ],
        // siteMobile: [
        //   { required: true, prop:'联系方式', message: '联系方式不能为空', trigger: 'blur' }
        // ],
        applyContent: [
          {required: true, prop: '申请内容', message: '申请内容不能为空', trigger: 'blur'}
        ],
        // applyContnetExtend: [
        //   { required: true, prop:'补充申请内容', message: '补充申请内容不能为空', trigger: 'blur' }
        // ],
        // checkBy: [
        //   { required: true, prop:'审核人', message: '审核人不能为空', trigger: 'blur' }
        // ],
        // checkDate: [
        //   { required: true, prop:'审核时间', message: '审核时间不能为空', trigger: 'blur' }
        // ],
        // checkAmount: [
        //   { required: true, prop:'结算金额', message: '结算金额不能为空', trigger: 'blur' }
        // ],
        // checkNote: [
        //   { required: true, prop:'审核说明', message: '审核说明不能为空', trigger: 'blur' }
        // ],
        // checkFile: [
        //   { required: true, prop:'审核附件', message: '审核附件不能为空', trigger: 'blur' }
        // ],
        // diffFlag: [
        //   { required: true, prop:'服务商是否异议：0否1是', message: '服务商是否异议：0否1是不能为空', trigger: 'blur' }
        // ],
        // diffNote: [
        //   { required: true, prop:'异议说明', message: '异议说明不能为空', trigger: 'blur' }
        // ],
        // diffFile: [
        //   { required: true, prop:'异议附件', message: '异议附件不能为空', trigger: 'blur' }
        // ],
      },
      picList1: [],
      picList2: [],
      picList3: [],
      picList4: [],
      picList5: [],
      picList6: [],
      showPhotoList0: [],
      showPhotoList1: [],
      operationDTOList: [],

      showPhoto: true,
      checkSubjectOption: [],
      brandOptions: [],
      showSitePop: false,

      showProductCategoryDialog: false,

      upload_btn1: true,
      upload_btn2: true,
      upload_btn3: true,

      radio: '1',
      showEdit: false,

      activeName: 'first',
      dialog: {
        one: false,
      },
      isEdit: false,
      dataId: '',
    };
  },
  watch: {
    // 联系方式验证
    // callMobile1: {
    //   handler(newVal, oldVal) {
    //     // console.log(newVal,"新值");
    //     this.formData.siteMobile = newVal

    //     var numReg = /^[0-9]+$/
    //     var numRe = new RegExp(numReg)
    //     if (!numRe.test(this.formData.siteMobile)) {
    //       this.$message.error("请输入正确的11位手机号码");
    //     } else if (this.formData.siteMobile.length > 11) {
    //       this.$message.error("手机号码不能超过11位");
    //       this.formData.siteMobile = this.formData.siteMobile.slice(0, 11);
    //       this.callMobile1 = this.formData.siteMobile
    //     }
    //   },
    //   deep: true, // 加这个属性，深度监听
    // },
    'formData.adjustAmount': {
      handler(newVal, oldVal) {
        if (this.formData.standardAmount !== '' && !this.justShow) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
          this.formData.amount = this.formData.checkAmount
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    'formData.standardAmount': {
      handler(newVal, oldVal) {
        if (this.formData.adjustAmount !== '' && !this.justShow) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
          this.formData.amount = this.formData.checkAmount
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    'formData.checkSubjectId': {
      deep: true,
      handler(newVal) {
        this.checkSubjectSelectOne()
      }
    }
  },

  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },

  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    if (this.processId && !isNaN(this.processId)) this.wfData.wfEntityId = this.processId;
    this.editButton = this.permissions["wkFeeApplyEdit"];
    this.submitButton = this.permissions["wkFeeApplySubmit"]; //提交
    this.flowSubmitButton = this.permissions["wkFeeApplyFlowSubmit"]; //提交
    this.checkButton = this.permissions["wkFeeApplyCheck"]; //审核
    this.rejectButton = this.permissions["wkFeeApplyReject"]; //驳回
    this.cancelButton = this.permissions["wkFeeApplyCancel"]; //取消
    this.recallButton = this.permissions["wkFeeApplyFollowUp"]; //回访

    //特殊费用
    this.addButtonTsfy = this.permissions["wkFeeApplyAddTsfy"];
    this.editButtonTsfy = this.permissions["wkFeeApplyEditTsfy"];
    this.exportButtonTsfy = this.permissions["wkFeeApplyExportTsfy"];
    this.flowSubmitButtonTsfy = this.permissions["wkFeeApplyFlowSubmitTsfy"];
    this.checkButtonTsfy = this.permissions["wkFeeApplyCheckTsfy"];
    this.rejectButtonTsfy = this.permissions["wkFeeApplyRejectTsfy"];
    this.cancelButtonTsfy = this.permissions["wkFeeApplyCancelTsfy"];

    //质量问题
    this.addButtonZlwt = this.permissions["wkFeeApplyAddZlwt"];
    this.editButtonZlwt = this.permissions["wkFeeApplyEditZlwt"];
    this.exportButtonZlwt = this.permissions["wkFeeApplyExportZlwt"];
    this.flowSubmitButtonZlwt = this.permissions["wkFeeApplyFlowSubmitZlwt"];
    this.checkButtonZlwt = this.permissions["wkFeeApplyCheckZlwt"];
    this.rejectButtonZlwt = this.permissions["wkFeeApplyRejectZlwt"];
    this.cancelButtonZlwt = this.permissions["wkFeeApplyCancelZlwt"];
    //社会化
    this.addButtonShh = this.permissions["wkFeeApplyAddShh"];
    this.editButtonShh = this.permissions["wkFeeApplyEditShh"];
    this.exportButtonShh = this.permissions["wkFeeApplyExportShh"];
    this.flowSubmitButtonShh = this.permissions["wkFeeApplyFlowSubmitShh"];
    this.checkButtonShh = this.permissions["wkFeeApplyCheckShh"];
    this.rejectButtonShh = this.permissions["wkFeeApplyRejectShh"];
    this.cancelButtonShh = this.permissions["wkFeeApplyCancelShh"];


    console.log("权限", JSON.stringify(this.permissions))

    if (this.currentSiteData) {
      this.isSite = true;
      console.log("this.isSite = true;")
    }
  },

  mounted() {
    this.loadLoginIsSite()
    this.loadOrgData()
    this.getData()
    this.loadDictData()
    this.getProcessDefinitions()
  },

  methods: {
    closeD2() {
      this.showPreview = false

    },

    // 工单弹框选中
    // orderCommit(data) {
    //   console.log('选中的工单', data)
    //   this.formData.orderNo = data.orderNo
    //   this.formData.barcode = data.resultBarcode ? data.resultBarcode : ''
    //   if (data.settleType){
    //     this.selectSettleFeeType = data.settleType
    //     if (row.settleType == 19){
    //       this.selectSettleFeeType = 9
    //     }
    //   }
    //   this.applyTypeChange()
    // },
    feeTypeValueListChange(type){
      this.isSetSettleFeeType = false
      this.feeTypeValueList = []
      this.feeTypeValueList.push(this.feeTypeValue)
      console.log("this.feeTypeValueList-----------------",this.feeTypeValueList)
      console.log("this.isSpecialApplyType-----------------",this.isSpecialApplyType)
      this.feeTypeValueList.forEach(feeType=> {
          let a = []
          this.feeTypeList.forEach(item =>{
            // if (feeType == item.id && "安装维修费用核销"===item.label){
            //   if (this.isSpecialApplyType){
            //     this.canChangeSettleFee = true
            //   }
            //   this.isSetSettleFeeType = true
            // }
            console.log("feeType--------------",feeType)
            console.log("item--------------",item)
            if (feeType === item.id ){
              if ("安装维修费用核销"===item.label){
                console.log("this.isSpecialApplyType-----------------",this.isSpecialApplyType)
                if (this.isSpecialApplyType){
                  this.canChangeSettleFee = true
                }
                this.isSetSettleFeeType = true
                this.isFromFeeApply = 1
                let b = [];
                b.push(item.id);
                this.feeTypes = b
              }else{
                this.canChangeSettleFee = false
                this.isFromFeeApply = 2
              }
            }
            if ("安装维修费用核销"!==item.label) {
              a.push(item.id)
            }
          })

          // a
          if (this.isFromFeeApply == 2 && a.length > 0) {
            this.feeTypes = a;
          }
          console.log("this.feeTypes", this.feeTypes)
        }
      );
      if (!this.canChangeSettleFee && type == 1){
        this.formData.settleFeeType =null
        this.changeSettleFeeType()
      }
      this.applyTypeChange()
    },
    changeSettleFeeType(){
      this.formData.wkFeeApplyOrderList=[]
    },
    changeSite(){
      this.formData.wkFeeApplyOrderList=[]
    },
    searchOrder() {
      let errorMsg = '';
      if (!this.formData.siteId) {
        errorMsg += '网点 '
      }
      console.log("searchOrder")
      if (errorMsg) {
        this.$message.error("请选择" + errorMsg);
        return false;
      }

      this.showOrderPop = true;
    },
    importOrders(){
      let errorMsg = '';
      if (!this.formData.siteId) {
        errorMsg += '网点 '
      }
      if (errorMsg) {
        this.$message.error("请选择" + errorMsg);
        return false;
      }
      this.$refs.excelUpload.show()
    },
    deleteCompanyFeeMed(){
      let temp = this.formData.wkFeeApplyOrderList
      if (!this.selectedData || this.selectedData.length == 0) {
        this.$message.error('请先选中要删除的数据')
        return
      }
      this.selectedData.forEach(item => {
        temp = temp.filter(item1 => item1.orderId != item.orderId)
      })
      this.formData.wkFeeApplyOrderList = temp
    },
    applyTypeChange() {
      // this.formData.settleFeeType = null
      let applyType = this.formData.applyType;
      this.notFeeTypeFlag = false;
      this.needOrderNoAndBarCodeFlag = false
      if (applyType) {
        this.applyTypeList.some(item => {
          if (applyType === item.id && "社会化服务商退换货物流运输费申请" === item.label ) {
            // this.formData.settleFeeType = 2
          }
          if (applyType === item.id && "特殊费用核销申请" === item.label  && this.isSetSettleFeeType) {
            // if (this.selectSettleFeeType) {
            //   this.formData.settleFeeType = this.selectSettleFeeType
            // }
          }
          if (applyType === item.id && ("社会化服务商退换货物流运输费申请" === item.label || "申请类型2" === item.label)) {
            this.notFeeTypeFlag = true;
            this.needFee = false
            this.isSpecialApplyType = false
            this.feeTypeValueList = []
            if (!this.formData.id) {
              this.formData.applyContent = '根据社会化服务协议第七条第二点费用标准中第3点：经区域服务经理同意退换货产品产生的物流运输费（每台最高100元封顶）由华帝承担，按规定核销。  年   月我司通过批准后共退回产品   台（明细详见附件），现申请按协议规定给予核销物流运输费，请总部审批。'
            }
            return true;
          } else if (applyType === item.id && ("质量问题产品退回管理费核销申请" === item.label || "申请类型1" === item.label)) {
            this.needFee = false
            this.feeTypeValueList = []
            this.isSpecialApplyType = false
            return true;
          } else if (applyType === item.id && ("特殊费用核销申请" === item.label)) {
            this.needOrderNoAndBarCodeFlag = true
            this.isSpecialApplyType = true
            this.needFee = true

            if (!this.formData.id) {
              this.formData.applyContent = ''
            }

            return true;
          } else {
            this.needFee = true
            this.isSpecialApplyType = false
            if (!this.formData.id) {
              this.formData.applyContent = ''
            }
          }
        })
      }
    },
    // 文件下载
    handleDownload(Vname, Vurl) {
      console.log(Vname, Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },
    // 文件预览
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },
    loadDictData() {
      console.log("loadDictData >>>");
      loadDictData("申请类型").then(res => {
        this.applyTypeList = []
        res.data.data.forEach(item => {
          this.applyTypeList.push(
            item
          )
          if (this.applyTypeName == item.label) {
            this.formData.applyType = item.id
            this.applyTypeChange()
          }
        })
      })
      loadDictData("费用类型").then(res => {
        this.feeTypeList = []
        res.data.data.forEach(item => {
          this.feeTypeList.push(
            item
          )
        })
        if (this.dataId){
          this.feeTypeValueListChange(0)
        }
      })
    },
    reloadWf() {
      console.log('保存前的刷新');
      this.$emit('editViewDataUpdate')
    },

    showOrderRemaek() {
      console.log("submitButton", this.submitButton)
      console.log("recallButton", this.recallButton)
      if (!this.recallButton) {
        this.$message.warning('没有回访权限')
      } else {
        this.showOrderRemaekDialog = true;
      }
    },

    // 返回列表页
    goBackIndex() {
      this.$emit('goBackIndex')
    },

    deleteRecalls(row) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'deleteRecalls')
        this.formData.virtualBarcodeBillRecalls = this.formData.virtualBarcodeBillRecalls.filter(item => item.recallRemark !== row.recallRemark)
      })
    },

    getData() {
      // console.log('getData',this.dataId)
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.wkFeeApply.getDataUrl + this.dataId,
          method: 'get',
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          this.formData = data
              this.applyTypeList.some(item => {
                if (this.formData.applyType === item.id && ("特殊费用核销申请" === item.label)){
                  this.needOrderNoAndBarCodeFlag = true
                  this.isSpecialApplyType = true
                  this.needFee = true
                }

              })
          if (data.settleFeeType){
            this.isSetSettleFeeType = true
            this.selectSettleFeeType = data.settleFeeType
          }
          this.fixData = {...{}, ...data}
          this.callMobile1 = this.formData.siteMobile

          if (this.justShow) {

          } else {
            this.orgValue = data.orgId
            this.loadProductOption1()
          }
          this.justShow = this.formData.stat != 1
          if (!!data.feeType) {
            if (data.feeType.includes(",")){
              this.feeTypeValue = data.feeType.split(",")[0]
            }else{
              this.feeTypeValue = data.feeType
            }
            this.feeTypeValueListChange(0)
            // this.feeTypeValueList.push(this.feeTypeValue)
          }
          console.log("this.feeTypeValue", this.feeTypeValue)
          console.log("this.feeTypeValueList", this.feeTypeValueList)
          console.log('费用核销修改',this.formData.feeTypeName )
          console.log(' this.formData.wkFeeApplyOrderList', this.formData.wkFeeApplyOrderList);
          let arry = []
          if(this.formData.feeTypeName  && (this.formData.feeTypeName == '返厂核销' || this.formData.feeTypeName == '不返厂核销' ) ){
              this.formData.wkFeeApplyOrderList.forEach(item=>{
                item.canChangePartsQty = true
                arry.push(item)
              })
            this.formData.wkFeeApplyOrderList = arry;
          }

          console.log("this.formData.wkFeeApplyOrderList ",this.formData.wkFeeApplyOrderList )
          let arr = []
          arr.push(
            {
              name: "",
              url: this.formData.checkFile,
            }
          )
          this.checkFile = arr

          this.applyTypeChange();
        })
      } else {
        this.enabled = true;
        if (this.currentSiteData !== null) { //网点端
          console.log("this.currentSiteData", this.currentSiteData)
          this.formData.siteName = this.currentSiteData.userName
          this.formData.siteId = this.currentSiteData.id
          this.orgValue = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
          this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
        }
      }
    },

    // 加载产品小类
    loadProductOption1() {
      this.formData.categoryName = this.formData.bigCategoryName + "/" + this.formData.smallCategoryName
    },
    upVideo() {
      this.$mask.open()

    },
    handleFileSuccess(res, file, fileList) {
      let url = res.data.url
      let fileName = file.name
      console.log(url, "url")
      console.log(fileName, "name")
      this.formData.fileList.push({
        fileName: fileName,
        fileUrl: url
      })
      this.$message({
        message: '附件上传成功',
        type: 'success'
      });
      this.$mask.close()
    },

    deleteFile(row) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'delete')
        this.formData.fileList = this.formData.fileList.filter(item => item.fileUrl !== row.fileUrl)
      })
    },
    changeCheckAmount(row){
      if(!this.currentIsSite){
        let applyAmount = !row.applyAmount?0:row.applyAmount;
        let hxRate = !row.hxRate?0:row.hxRate;
        row.checkAmount = (applyAmount * hxRate /100).toFixed(2)
      }
    },
    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },
    changePartsApply(row){
      this.currentRowData = row
      this.showPartsApply = true;
    },
    changeOrderPartsApply(row){
      this.currentRowData = row
      this.showOrderPartsApply = true;
    },
    followUpOrderRemark(data) {
      this.showOrderRemaekDialog = false;
      console.log("回访数据", data)
      if (!this.formData.virtualBarcodeBillRecalls) {
        this.formData.virtualBarcodeBillRecalls = []
      }
      console.log("回访数据", data)
      let filter = this.formData.virtualBarcodeBillRecalls.filter(item => item.huiFangQingKuang !== data.huiFangQingKuang)
      filter.push(data)
      this.formData.virtualBarcodeBillRecalls = filter
      console.log("this.formData.virtualBarcodeBillRecalls", this.formData.virtualBarcodeBillRecalls)
    },

    editViewDataUpdate() {
      this.$emit('editViewDataUpdate')
      this.$emit('changeTab')
    },

    handlePreview(file) {
      console.log(file);
    },

    //抽屉关闭后改变父组件的visible的值
    closeD(v) {
      this.showConfirmDialog = false
      this.showCloseDialog = false
      this.showAuditDialog = false
      // this.flushed()
    },

    closeImgViewer() {
      this.dialogVisible = false
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrlList = [file.url]
      this.dialogVisible = true
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    checkSubjectSelectOne() {
      if (this.formData.checkSubjectId) {
        this.$http.post(api.basCheckSubject.getDataUrl, {id: this.formData.checkSubjectId}).then(res => {
          let data = res.data.data
          this.formData.standardAmount = data.standardAmount
          this.formData.feeAttributeName = data.feeAttributeName
          this.formData.feeAttributeId = data.feeAttributeId
          this.formData.isNeedSiteComplain = data.isNeedSiteComplain
        })
        console.log(this.formData)
        // this.processId = this.formData.processId;
        // console.log(this.processId,'this.processId的值');
      } else {
        this.formData.standardAmount = 0
        this.formData.feeAttributeName = null
        this.formData.feeAttributeId = null
        this.formData.isNeedSiteComplain = null
      }
    },

    //加载判断当前登录是否网点
    loadLoginIsSite() {
      this.$http({
        url: api.snUser.getLoginIsSite,
        method: 'post',
        data: {}
      }).then(res => {
        console.log("this.currentSiteData", this.currentSiteData)
        console.log("当前登录信息", res.data)
        if (res.data.data.userType != null) {
          this.formData.siteMan = this.currentSiteData.snSiteInfoDTO.siteMan
          this.formData.siteMobile = this.currentSiteData.snSiteInfoDTO.siteManMobile
          this.orgValue = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
          this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
          this.formData.siteName = this.currentSiteData.userName
          this.formData.siteId = this.currentSiteData.id

        }
      })
    },

    // 加载机构数据
    loadOrgData() {
      fetchTree(this.queryParams).then(response => {
        this.orgOptions = response.data.data
        // this.orgOptions =res.data.data
        console.log(this.orgOptions, "this.orgOptions的值");

      });

    },

    // 机构选中
    orgHandleChange(data) {
      if (data.length !== 0) {
        this.$http({
          url: '/admin/dept/' + data[data.length - 1],
          method: 'get'
        }).then(res => {
          console.log('选中机构', res.data.data)
          this.formData.orgId = res.data.data.deptId
          this.formData.orgName = res.data.data.name
          this.formData.orgIdPath = res.data.data.orgIdPath
        })
      }
    },

    saveData() {
      let applyType = this.formData.applyType;
      if (applyType) {
        this.applyTypeList.forEach(item => {
          if (applyType === item.id) {
            this.formData.applyTypeName = item.label
          }
        })
      }
      this.formData.feeType = ""
      this.formData.feeTypeName = ""
      if (this.feeTypeValueList && this.feeTypeValueList.length > 0) {
        this.formData.feeType = this.feeTypeValueList.join()
      }
      console.log("this.formData.feeType", this.feeTypeValueList)
      console.log("this.formData.feeType", this.formData.feeType)
      if (!!this.formData.feeType) {
        let feeTypeName = [];
        this.feeTypeList.forEach(item => {
          if (this.formData.feeType.indexOf(item.id) != -1) {
            feeTypeName.push(item.label)
          }
        })
        this.formData.feeTypeName = feeTypeName.join()
      }
      if (this.canChangeSettleFee){
        if (!this.formData.settleFeeType){
          this.$message.error("费用结算类型必填");
          return false;
        }
      }
      console.log("this.formData.feeType" + this.formData.feeType)
      console.log("this.formData.feeTypeName" + this.formData.feeTypeName)
      console.log("this.formData.applyTypeName" + this.formData.applyTypeName)

      console.log("", this.needFee, this.formData.feeType)
        if (this.formData.wkFeeApplyOrderList.length > 0) {
          var errorMsg = null
          this.formData.wkFeeApplyOrderList.forEach(item => {
            var itemErrorMsg = null;
            if (!item.barcode){
              if (itemErrorMsg == null){
                itemErrorMsg = "工单:"+item.orderNo+"条码必填";
              }else{
                itemErrorMsg = itemErrorMsg+",条码必填";
              }
            }
            if (!item.content){
              if (itemErrorMsg == null){
                itemErrorMsg = "工单:"+item.orderNo+"申请内容必填";
              }else{
                itemErrorMsg = itemErrorMsg+",申请内容必填";
              }
            }
            if(item.applyAmount == null){
              if (this.currentIsSite){
                //网点端隐藏了填写
                item.applyAmount = 0
              }
            }
            if (item.applyAmount == null){
              if (itemErrorMsg == null){
                itemErrorMsg = "工单:"+item.orderNo+"申请金额必填";
              }else{
                itemErrorMsg = itemErrorMsg+",申请金额必填";
              }
            }
            if (errorMsg){
              errorMsg = errorMsg+'<br/><br/>'+ itemErrorMsg
            }else{
              errorMsg = itemErrorMsg
            }
          })
          if (errorMsg){
            this.$message({
                  message:errorMsg,
                  dangerouslyUseHTMLString: true,
                  type: "error"
            });
            return false;
          }
        }
      if (this.needFee && !this.formData.feeType) {
        this.$message.error("费用类型必填");
        return false;
      }
      // if (this.needOrderNoAndBarCodeFlag && !this.formData.orderNo) {
      //   this.$message.error("工单号必填");
      //   return false;
      // }
      this.$validate(this.formData, this.dataRule).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()

          var url = (this.isEdit ? api.wkFeeApply.updateDataUrl : api.wkFeeApply.addDataUrl);
          var method = (this.isEdit ? 'put' : 'post');
          this.$http({
            url: url,
            method: method,
            data: this.formData,
            isLoading: true,
          }).then(response => {
            this.$message.success("保存成功！");
            this.reload()
            this.$mask.close()

            // this.$emit('editViewDataUpdate')
            // this.$baseReload()
          }).catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close()
          });
        })
      })

      //   this.$validate(this.formData, this.rules)
      //   this.$refs.editForm.validate(valid => {
      //     if (valid) {
      //       this.$baseConfirm('您确定要保存吗？').then(() => {
      //         this.$mask.open()
      //         this.formData.siteMobile = this.callMobile1

      //         var method = (this.isEdit ? 'put' : 'post');
      //         var url = (this.isEdit ? api.wkFeeApply.updateDataUrl : api.wkFeeApply.addDataUrl);
      //         this.$http({
      //           url: url,
      //           method: method,
      //           data: this.formData,
      //           isLoading: true,
      //         }).then(res => {
      //           this.$message.success('保存成功')
      //           this.reload()
      //           this.$mask.close()
      //         }).catch(() => {
      //           this.$message.error("保存失败！");
      //           this.$mask.close()
      //         });
      //       });
      //     }
      //   });


    },

    cancelForm() {
      this.loading = false;
      this.initiateAppeal = false;
      clearTimeout(this.timer);
    },
    commitPartsApplyNoRow(data){
      //获取到的数据
      console.log('配件数据1：',data)
      if(!data.applyQty || data.applyQty == 0){
        data.applyQty = 1
      }
      this.currentRowData.partsApplyNo = data.applyNo
      this.currentRowData.partsCode = data.partsCode
      this.currentRowData.partsName = data.partsName;
      this.currentRowData.partsQty = data.applyQty *1
      this.currentRowData.canChangePartsQty = true
      console.log('修改完后数据1：',this.currentRowData)

    },
    commitPartsSelectNoRow(data){
      //获取到的数据
      console.log('配件数据2：',data);
      if(!data.qty || data.qty == 0){
        data.qty = 1
      }
      this.currentRowData.partsCode = data.partsCode
      this.currentRowData.partsQty = data.qty *1
      this.currentRowData.partsName = data.partsName;
      this.currentRowData.sitePrice = data.sitePrice;
      this.currentRowData.applyAmount = (data.qty * data.sitePrice).toFixed(2)
      this.currentRowData.checkAmount =  (data.qty * data.sitePrice).toFixed(2)
      this.currentRowData.canChangePartsQty = true
      console.log('修改完后数据2：',this.currentRowData)
    },
    // 工单弹窗选中
    orderCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.orderNo = row.orderNo
      this.formData.orderId = row.orderId
      this.formData.serviceTypeName = row.serviceTypeName
      this.formData.serverTypeId = row.serverTypeId
      this.formData.userName = row.userName
      this.formData.userMobile = row.userMobile
      this.formData.itemCode = row.itemCode
      this.formData.itemName = row.itemName
      this.formData.categoryName = row.bigCategoryName + "/" + row.smallCategoryName
      this.formData.bigCategoryName = row.bigCategoryName
      this.formData.smallCategoryName = row.smallCategoryName
      this.formData.bigCategoryId = row.bigCategoryId
      this.formData.smallCategoryId = row.smallCategoryId
      this.formData.barcode = row.barcode
      this.formData.buyDate = row.buyDate
      this.formData.itemId = row.itemId

      // if (row.settleType){
      //   this.selectSettleFeeType = row.settleType
      //   if (row.settleType == 19){
      //     this.selectSettleFeeType = 9
      //   }
      // }
      // this.applyTypeChange()
      let rowData = {
        orderId: row.orderId,orderNo:row.orderNo,barcode:row.resultBarcode,brandName:row.brandName
      }
      console.log("rowData-----------",rowData)
      var isIn = false;
      this.formData.wkFeeApplyOrderList.forEach(item => {
        if (item.orderId == rowData.orderId){
          isIn = true;
        }
      })
      console.log('this.applyTypeName',this.applyTypeName)
      console.log('this.feeTypeValue',this.feeTypeValue)
      let isTeshufeiyong = false
      let isFanchang = false
      this.applyTypeList.some(item => {
        if (this.formData.applyType === item.id && ("特殊费用核销申请" === item.label)){
          isTeshufeiyong = true
        }
      })
      this.feeTypeList.some(item=>{
        if (this.feeTypeValue === item.id && ('返厂核销' === item.label || '不返厂核销'  === item.label)){
          isFanchang = true
        }
      })
      if(isTeshufeiyong && isFanchang){
        isIn = false;
        rowData = {
          orderId: row.orderId,orderNo:row.orderNo,barcode:row.resultBarcode,brandName:row.brandName,canChangePartsQty:true,hxRate:100,partsQty:0
        }
      }
      if (!isIn){
        this.formData.wkFeeApplyOrderList.push(rowData)
      }

    },
    //导入返回
    refreshChange(data){
        data.forEach(importItem => {
          var isIn = false;
          this.formData.wkFeeApplyOrderList.forEach(item => {
            if (item.orderId == importItem.orderId){
              isIn = true;
            }
          })
          if (!isIn){
            this.formData.wkFeeApplyOrderList.push(importItem)
          }
        })
    },

    // 网点弹窗选中
    siteCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.siteId = row.id
      this.formData.siteName = row.name
      this.orgValue = row.orgId
      this.formData.orgId = row.orgId
      this.formData.orgName = row.orgName
      this.formData.orgIdPath = row.orgIdPath
      this.formData.siteMan = row.siteMan
      this.formData.siteMobile = row.siteManMobile
    },
    getProcessDefinitions() {
      request({
        url: api.act.getProcessDefinitionsUrl,
        method: 'post',
        // data:this.formData,
        data: {tableKey: "WkFeeApply",},
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.processDefinitions = response.data.data
      })
    },
    startFlow() {

      console.log("startFlow!!")
      let applyType = this.formData.applyType;
      if (applyType) {
        this.applyTypeList.forEach(item => {
          if (applyType === item.id) {
            this.formData.applyTypeName = item.label
          }
        })
      }
      if (!applyType || !this.formData.applyTypeName) {
        this.$message.error('请选择申请类型');
        return;
      }


      if (!this.processDefinitions || this.processDefinitions.length < 1) {
        this.$message.error('未获取到费用申请单流程');
        return;
      }
      let wfName = ("费用申请单-" + this.formData.applyTypeName)
      console.log("申请类型：",this.formData.applyTypeName)
      if(this.formData.applyTypeName === '特殊费用核销申请' && !this.currentIsSite){
        wfName  = "特殊费用核销申请单总部发起流程";
      }
      if(this.formData.applyTypeName === '特殊费用核销申请' && this.currentIsSite ){
        let feetypelabel = ''
        console.log("applyTypeList", this.feeTypeList)
        console.log("feeTypeValue",this.feeTypeValue)

        this.feeTypeList.forEach(item=>{
          if(item.id === this.feeTypeValue){
            feetypelabel = item.label
          }
        })
        console.log("feetypelabel-----------",feetypelabel)
        if(feetypelabel == '安装维修费用核销'){
          wfName = '费用申请单-特殊费用核销申请'
        }else{
          wfName  = "特殊费用核销申请-服务商返厂核销和不返厂核销流程"
        }
      }
      let processDefinitionId = null
      console.log("processDefinitionId", this.processDefinitions)
      this.processDefinitions.forEach(element => {
        if (element.wfName == wfName) {
          processDefinitionId = element.id
        }
      });
      console.log("wfName",wfName)
      console.log("applyTypeName",this.formData.applyTypeName)
      console.log("processDefinitionId", processDefinitionId)
      if (!processDefinitionId) {
        this.$message.error('未找到对应流程');
        return;
      }
      this.$baseConfirm('您确定要启动流程吗？').then(() => {
        this.$mask.open()
        console.log("this.$mask.open()")
        this.$http({
          url: api.act.startWfUrl,
          method: 'post',
          data: {
            id: this.formData.id,
            tableKey: "WkFeeApply",
            orgId: this.formData.orgId,
            orderNo: this.formData.applyNo,
            processDefinitionId: processDefinitionId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$message({message: response.data.content, type: 'success'});
            this.reload();
          } else {
            this.$message({message: response.data.content, type: 'warning'});
          }
          this.$mask.close()
        })
      })
    },
  },
};

</script>
<style lang="scss" scoped>
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 165px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 80px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 1px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  // border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 656px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  // background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}


#containt .detail-wrap .d-cont {
  overflow: unset !important;
  margin: 0 !important;
  padding: 0 !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

::v-deep .el-image {
  width: 60px;
}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.Instructions {
  text-decoration: underline;
  color: #00c4b3;
  margin-left: 5px;
}
</style>
